import { Component, OnInit, ViewChild, ViewChildren, QueryList } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppBreadcrumbService } from '../../app.breadcrumb.service';
import { ValidateformComponent } from '../../common/validateform/validateform.component';
import { NgForm } from '@angular/forms';
import { UserService } from '../../services/UserService';
import { AlertService } from '../../services/AlertService';
import { ConfirmationService } from 'primeng/api';
import { AccountService } from '../../services/AccountService';
import { MemberService } from '../../services/MemberService';
import { environment } from '../../../environments/environment';
import { FileUpload } from 'primeng/fileupload';

interface Member{
    Id: number,
    MemberID: number,
    IsDefaultMember: boolean,
    Title: string,
    OfficePhone: string,
    Fax: string,
    Email: string,
}

@Component({
  selector: 'app-user-edit',
  templateUrl: './user-edit.component.html',
  styleUrls: ['./user-edit.component.scss']
})
export class UserEditComponent implements OnInit {
    @ViewChildren(FileUpload) pFileUploads: QueryList<any>;
    @ViewChild('f', { static: true }) editUserForm: NgForm;
    @ViewChild(ValidateformComponent, { static: true }) private formValidator: ValidateformComponent;
    user: any;
    options: any;
    parentOfficeOptions: any[] = [];
    roleOptions: any[] = [];
    appRoleOptions: any[] = [];
    specialtyOptions: any[] = [];

    OriginalEmail: string = '';
    selectedAppRoles: any[] = [];
    
    showEditOffice: boolean = false;
    selectedOffice: any;
    originalOffice: any;
    selectedRoles: any[] = [];

    showAddOffice: boolean = false;
    AddOfficeParentOfficeId: number = 360;
    childOffices: any[] = [];
    selectedChildOffices: any[] = [];
    hasChildOffices: boolean = false;

    showDuplicateItemDialog: boolean = false;
    duplicateItemMessage: string = '';

    showUpdateSpecialtiesDialog: boolean = false;
    originalSpecialtyOptions: any;
    newSpecialty: string = '';
    canEditProfile: boolean = false;
    canActivateUser: boolean = false;
    enableOfficeManagerRole: boolean = false;    
    enableAdminRole: boolean = false;
    uploadURLPhoto: string = '';

    constructor(private activatedRoute: ActivatedRoute,
        private breadcrumbService: AppBreadcrumbService,
        private userService: UserService,
        private alertService: AlertService,
        private router: Router,
        private confirmationService: ConfirmationService,
        private accountService: AccountService,
        private memberService: MemberService,) { }    

    ngOnInit(): void {
        this.initializeVariables();
        this.user = this.activatedRoute.snapshot.data['user'];
        this.user.ProfilePicture = 'data:image/png;base64,' + this.user.ProfilePicture;
        this.OriginalEmail = this.user.Email;
        this.options = this.activatedRoute.snapshot.data['options'];
        this.parseOptions();   
        this.initForm();
        this.accountService.CanEditProfile(this.user.Id).subscribe(canEdit => {
            this.canEditProfile = canEdit;
        });

        this.canActivateUser = this.accountService.CanActivateUser(this.user.Id);
        this.uploadURLPhoto = environment.apiBase.concat('User/UploadUserImage?userId=', this.user.Id);
       
        this.breadcrumbService.setItems([            
            { label: 'Edit Broker #' + this.user.Id, routerLink: [] }
        ]);
    }
    parseOptions() {
        this.parentOfficeOptions = new Array();
        for (let o of this.options[0]) {
            let l = o.Name;
            this.parentOfficeOptions.push({ label: l, value: o.Id });
        }

        this.roleOptions = this.options[1];
        for (var role of this.roleOptions) {
            switch (role.Id) {
                case 1: { role.ToolTip = 'By not checking this box, this profile will not appear on www.naiglobal.com'; break; }
                case 2: { role.ToolTip = 'Main POC for your firm to handle all deal flow'; break; }
                case 4: { role.ToolTip = 'All professional staff should be checked off'; break; }
                case 5: { role.ToolTip = 'Main POC for meetings and communications'; break; }
                case 6: { role.ToolTip = 'Principal, director or manager - All owners or broker managers should be checked off'; break; }
                case 7: { role.ToolTip = 'All active agent/brokers should be checked off'; break; }                    
            }
        }

        this.appRoleOptions = this.options[2];
        this.specialtyOptions = this.options[3];

        for (var role of this.appRoleOptions) {
            if (role.Name == 'admin')
                role.Description = 'NAI Global Staff';
            if (role.Name == 'officemanager')
                role.Description = 'Office Manager';
            if (role.Name == 'user') {
                role.Description = 'User';
            }
            if (role.Name == 'editownprofile') {
                role.Description = 'Allowed to edit own profile';
            }
        }          
    }

    initializeVariables() {
        this.parentOfficeOptions = [];
        this.roleOptions = [];
        this.appRoleOptions = [];
        this.selectedAppRoles = [];
        this.user = {};
        this.selectedOffice = { Title: '', OfficePhone: '', Fax: '', Email: '', IsDefaultMember: false };
        this.childOffices = [];
        this.selectedChildOffices = [];
        this.hasChildOffices = false;
    }

    initForm() {
        for (var roleOption of this.appRoleOptions) {
            for (var role of this.user.AspNetRoles) {
                if (roleOption.Name == role) {
                    this.selectedAppRoles.push(roleOption);
                }
            }          
        }       
    }

    saveUser() {
        this.user.AspNetRoles = [];
        for (var role of this.selectedAppRoles) {
            this.user.AspNetRoles.push(role.Name);
        }

        if (this.OriginalEmail != this.user.Email) {
            this.confirmationService.confirm({
                key: "userEditConfirmDialog",                
                message: "Changing the email address will change the user's logon name and email address used for communication from NAI.<br> Are you sure you want to make this change?",
                accept: () => {
                    this.user.UpdateLogonEmail = true;
                    this.updateUser();
                }
            });
        }
        else {
            this.updateUser();
        }            
    }

    updateUser() {
        if (this.formValidator.validateForm()) {
            //add LastChange for user.Members
            var defaultoffice = this.user.Members.filter(m => m.IsDefaultMember == true && m.Member.Active == true);
            if (defaultoffice.length == 0) {
                
                this.alertService.SetMessage('error', 'User must have a default office selected.');
            }
            else
            {
                this.userService.updateUser(this.user).subscribe(
                    result => {
                        this.pFileUploads.forEach(pFileUpload => this.uploadFiles(pFileUpload));      
                        if (this.user.UpdateLogonEmail || (this.user.Id == this.accountService.userValue.broker.Id && !this.user.AspNetRoles.includes('admin') && !this.user.AspNetRoles.includes('editownprofile'))) {
                            this.accountService.LogOut();
                            this.alertService.SetMessage('success', 'Your profile is Updated. Please re-login.');
                        }
                        else {
                            this.router.navigate(['/user/' + this.user.Id]);
                            this.alertService.SetMessage('success', 'User is Updated.');
                        }                    
                    },
                    error => {
                        this.alertService.SetMessage('error', 'There is an error while updating user');
                    }
                
                );
            }
        } 
    }

    showEdit(row) { 
        this.showEditOffice = true;
        this.selectedOffice = row;
        this.originalOffice = row ? JSON.stringify(row) : null;

        this.selectedRoles = [];
        if (this.selectedOffice.Roles != undefined && this.selectedOffice.Roles.length > 0) {
            for (var j = 0; j < this.selectedOffice.Roles.length; j++) {
                var r = this.roleOptions.filter(r => r.Id == this.selectedOffice.Roles[j].Id)[0];
                this.selectedRoles.push(r);
            }  
        }
        this.selectedOffice.Roles = [];
        this.selectedOffice.Roles = [...this.selectedRoles];
    }

    saveOffice() {        
        if (this.selectedOffice.IsDefaultMember) {
            this.confirmationService.confirm({
                key: "userEditConfirmDialog",
                message: "Are you sure you want to set this office as your default office?",
                accept: () => {
                    var indexOfDefault = this.user.Members.indexOf(this.selectedOffice);
                    var offices = this.user.Members;
                    for (var Office of offices) {
                        var index = this.user.Members.indexOf(Office);
                        if (index != indexOfDefault) {
                            offices[index].IsDefaultMember = false;
                        }                            
                    }
                    this.user.Members = [...offices];               
                    this.showEditOffice = false;
                }
            });
        }
        else {
            this.showEditOffice = false;
        }
    }

    cancelSaveOffice() {
        var backup = JSON.parse(this.originalOffice);
        var index = this.user.Members.indexOf(this.selectedOffice);
        this.selectedOffice = { ...backup };
        this.user.Members[index] = this.selectedOffice;
        this.showEditOffice = false;
    }

    showAdd() {
        this.showAddOffice = true;
        this.clearAddOfficeInfo();
        this.onParentOfficeChange();
    }

    addOffice() {
        this.duplicateItemMessage = 'Duplicate member(s) and will not be added:';
        var duplicateMember = [];
        for (var o of this.selectedChildOffices) {
            let member = {Id: 0, MemberID: '', Title: '', OfficePhone: '', Fax: '', Email: '', Member: {}, IsDefaultMember: false };
            member.MemberID = o.Id;
            member.Member = o;
            var duplicate = this.user.Members.filter(m => m.MemberID == o.Id);
            if (duplicate.length == 0) {
                this.user.Members.push(member);
            } else {
                duplicateMember.push(duplicate[0]);
            }
        }

        if (duplicateMember.length > 0) {
            this.showDuplicateItemDialog = true;
            for (var office of duplicateMember) {
                this.duplicateItemMessage += '\n' + office.Member.Name + ', ' + office.Member.City;
            }
        }

        this.showAddOffice = false;
    }

    hideDuplicateItemDialog() {
        this.showDuplicateItemDialog = false;
    }

    clearAddOfficeInfo() {
        this.childOffices = [];
        this.selectedChildOffices = [];
        this.AddOfficeParentOfficeId = 360;
    }

    cancelAddOffice() {
        this.showAddOffice = false;
        this.clearAddOfficeInfo();
    }
    shouldDisableSecurityRoleCheckbox(rolename:string)
    {
        if(rolename === 'officemanager')
        {
            return !this.accountService.CanDesignateOfficeManager();
        }
        if(rolename === 'admin')
        {
            return !this.accountService.CanDesignateAdmin();
        }
        if (rolename == 'editownprofile')
        {
            return !this.canEditProfile; 
        }
        return true; 
    }
    

    onParentOfficeChange() {
        this.childOffices = [];
        this.selectedChildOffices = [];
        if (this.AddOfficeParentOfficeId != undefined && this.AddOfficeParentOfficeId > 0) {
            this.memberService.GetChildOfficesByParentOfficeId(this.AddOfficeParentOfficeId).subscribe(
                result => {
                    this.childOffices = result;
                    if (this.childOffices != undefined && this.childOffices.length > 1)
                        this.hasChildOffices = true;
                    else {
                        this.hasChildOffices = false;
                        if (this.childOffices != undefined && this.childOffices.length == 1) {
                            this.selectedChildOffices = this.childOffices;
                        }
                    }
                },
                error => {
                    this.alertService.SetMessage('error', 'There is an error while getting child offices!');
                }
            );
        }       
    }

    deleteOffice(row) {
        if(row.IsDefaultMember == true)
        {
            this.alertService.SetMessage('error', 'Cannot remove default office from user profile. Please designate another office as default before removing this office');
            return;
        }
        
        this.confirmationService.confirm({
            key: "userEditConfirmDialog",
            message: "Are you sure you want to delete this office?",
            accept: () => {
                if (row.Id != undefined && row.Id != 0) {
                    this.user.Members.splice(this.user.Members.findIndex(function (i) {
                        return i.Id === row.Id;
                    }), 1);
                }
                else {
                    this.user.Members.splice(this.user.Members.findIndex(function (i) {
                        return (i.Member.City == row.Member.City && i.Member.Name == row.Member.Name && i.Member.StatesName == row.Member.StatesName);
                    }), 1);
                }
                    
            }
        });
    }

    showUpdateSpecialties() {
        this.newSpecialty = '';
        this.showUpdateSpecialtiesDialog = true;
        this.originalSpecialtyOptions = JSON.stringify(this.specialtyOptions);
    }

    saveSpecialties() {      
        this.userService.updateSpecialtyList(this.specialtyOptions).subscribe(
            result => {
                this.specialtyOptions = result;
                this.alertService.SetMessage('success', 'Specialty list is updated.');
            },
            error => {
                this.alertService.SetMessage('error', 'There is an error while updating specialty list.');
                this.specialtyOptions = JSON.parse(this.originalSpecialtyOptions); 
            }
        );
        this.showUpdateSpecialtiesDialog = false;
    }

    cancelSpecialties() {
        this.showUpdateSpecialtiesDialog = false;
        this.specialtyOptions = JSON.parse(this.originalSpecialtyOptions); 
    }

    deleteSpecialty(row) {
        this.confirmationService.confirm({
            key: "userEditConfirmDialog",
            message: "Are you sure you want to delete this office?",
            accept: () => {
                if (row.Id != undefined && row.Id != 0) {
                    this.specialtyOptions.splice(this.specialtyOptions.findIndex(function (i) {
                        return i.Id === row.Id;
                    }), 1);
                }
                else {
                    this.specialtyOptions.splice(this.specialtyOptions.findIndex(function (i) {
                        return (i.Name == row.Name);
                    }), 1);
                }
            }
        });
    }

    addSpecialty() {
        if (this.newSpecialty.trim() == '') {
            this.showDuplicateItemDialog = true;
            this.duplicateItemMessage = 'Unable to add an empty specialty.';
        } else {
            this.duplicateItemMessage = 'Duplicate specialty and will not be added:';
            var duplicate = this.specialtyOptions.filter(m => m.Name == this.newSpecialty);
            if (duplicate.length == 0) {
                this.specialtyOptions.push({ Name: this.newSpecialty });
                this.newSpecialty = '';
            } else {
                this.showDuplicateItemDialog = true;
                this.duplicateItemMessage += '\n' + duplicate[0].Name;
            }          
        }        
    }

    onChangeActivateProfile() {
        if (this.user.Active == false) {
            this.confirmationService.confirm({
                key: "userEditConfirmDialog",
                message: "Are you sure you want to de-activate this user?",
                accept: () => { },
                reject: () => { this.user.Active = true; }
            });
        }
    }
    onBeforeUploadProfilePicture(event) {
        if (this.user.Id != undefined && this.user.Id != 0) {
            event.formData.append('userId', this.user.Id);
        }
        else {
            event.xhr.abort();
            event.xhr = null;
            event.stopPropogation();
            this.alertService.SetMessage('error', 'There is an error while uploading file');
        }
    }
    onUploadCompletedProfilePicture(event) {
        if (event.originalEvent.ok) {}
        else {
            this.alertService.SetMessage('error', 'There is an error while uploading file');
        }
    }
    uploadFiles(pFileUpload: FileUpload) {
        if (pFileUpload.files.length > 0) {
            pFileUpload.upload();
        }
    }
}
